<template>
  <div class="projectDetail">
    <div class="project-info" v-if="tenderFlag === 2">
      <div class="announcementTitle" v-if="listDetail.oldInfo">澄清后公告：</div>
      <projectInfo :project="listDetail"  :projectId="$route.query.id" :oldInfo="0"/>
      <div class="announcementTitle" v-if="listDetail.oldInfo">原公告：</div>
      <projectInfo :project="listDetail.oldInfo"  :projectId="$route.query.id"  :oldInfo="1" :typeText="'你已投标'"/>
    </div>
    <div class="project-info" v-else>
      <div class="announcementTitle" v-if="listDetail.oldInfo">澄清后公告：</div>
      <projectInfo :project="listDetail"  :projectId="$route.query.id"  :oldInfo="0"/>
      <div class="announcementTitle" v-if="listDetail.oldInfo">原公告：</div>
      <projectInfo :project="listDetail.oldInfo"  :projectId="$route.query.id"  :oldInfo="1"/>
    </div>
  </div>
</template>

<script>
import { getNormalProjectInfo, getProjectTenderFlag } from '@api/project'
import projectInfo from '@views/components/projectInfo'
export default {
  name: 'projectDetail',
  components: {
    projectInfo
  },
  data () {
    return {
      listDetail: {},
      tenderFlag: '', // 投标状态：0-未报名；1-已报名未投标；2-已投标
      signFlag: ''
    }
  },
  created () {
    this.getNormalProjectInfo()
    this.getProjectTender()
  },
  methods: {
    // 获取项目详情
    getNormalProjectInfo () {
      getNormalProjectInfo({ id: this.$route.query.id }).then(res => {
        if (res.data.code === 200) {
          this.listDetail = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getProjectTender () {
      getProjectTenderFlag({
        projectId: this.$route.query.id
      }).then(res => {
        if (res.data.code === 200) {
          this.tenderFlag = res.data.data.tenderFlag
          this.signFlag = res.data.data.signFlag
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
  }
}
</script>

<style scoped>
.projectDetail{
  width: 75%;
}
</style>
